import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogConfirmComponent} from 'src/app/+home/shared/components/dialog-confirm/dialog-confirm.component';
import {CommentService} from 'src/app/viewer/services/comment.service';
import {StorageService} from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'app-dialog-comment',
  templateUrl: './dialog-comment.component.html',
  styleUrls: ['./dialog-comment.component.scss']
})
export class DialogCommentComponent implements OnInit {
  public comments: any[];
  public commentaire: string;
  public elementId: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogCommentComponent>,
    private commentService: CommentService,
    private dialog: MatDialog,
    public storage: StorageService
  ) {}

  ngOnInit() {
    this.commentService.getAllComment(this.data.elementId).then(res => {
      this.elementId = this.data.elementId;
      this.comments = res.items;
    });
  }
  delete(comment: any) {
    const commentToDelete = comment.name;
    let msg: string;
    if (this.storage.lang === 'fr') {
      msg = 'Souhaitez-vous réellement supprimer le commentaire  ?';
    } else if (this.storage.lang === 'en') {
      msg = 'Do you really want to delete the comment ?';
    }
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '40%',
      height: '20%',
      data: {
        text: msg
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.commentService.deleteComment(commentToDelete).then(res => {
          this.comments.splice(this.comments.indexOf(comment), 1);
        });
      }
    });
  }
  addComment() {
    const queries = '?reverse=true&startIndex=0&pageSize=10';
    const data = {
      content: this.commentaire
    };
    this.commentService.createComment(data, this.elementId).then(
      res => {
        this.comments.push(res.item);
        this.commentaire = '';
      },
      err => {}
    );
  }
}
